import React, { useEffect } from 'react'
import styled, { useTheme } from 'styled-components'
import Modal, { ModalProps } from '@/components/modal/Modal'
import Link from 'next/link'
import Icon from '../icon/Icon'
import { ArrowRight, Close, Sizes } from '@/components/icon/IconList'

export interface ToastModalProps extends ModalProps {
	text: string | React.ReactNode
	title?: string | React.ReactNode
	position?: { x: number; y: number; height: number }
	link?: string
	linkTitle?: string
	onClose: () => void
}

export const BottomDrawer: React.FC<ToastModalProps> = (props) => {
	const { text, title, position, link, linkTitle, ...rest } = props
	const theme = useTheme()
	//채널톡 이슈로 임시 모달로 ui변경
	return (
		<CustomModal {...rest}>
			<DrawerWrapper>
				<Icon
					onClick={props.onClose}
					icon={Close}
					size={Sizes.small}
					color={theme.new.colors.sol_gray_800}
				/>
				<h3>{title}</h3>
				<div className={'body'}>{text}</div>
				{link && (
					<Link target={'_blank'} href={link}>
						{linkTitle || '자세히 보기'}
					</Link>
				)}
			</DrawerWrapper>
		</CustomModal>
	)
}

const CustomModal = styled(Modal)`
	> div:last-child {
		padding: 20px;
		border-radius: 16px;
		@media (max-width: 1200px) {
			width: 50%;
		}
		@media (max-width: 768px) {
			//width: 90%;
			width: 360px;
		}
	}
`

const DrawerWrapper = styled.div`
	position: relative;
	h3 {
		color: ${(props) => props.theme.new.colors.sol_gray_800};
		font-size: 20px;
		font-weight: 700;
		margin-bottom: 16px;
		line-height: 1.5;
	}
	i {
		position: absolute;
		right: 0;
	}
	a {
		width: 100%;
		padding: 12px;
		line-height: 1.5;
		font-size: 16px;
		font-weight: 600;
		color: ${(props) => props.theme.new.colors.sol_indigo_500};
		border: 1px solid ${(props) => props.theme.new.colors.sol_indigo_500};
		border-radius: 6px;
		display: inline-block;
		text-align: center;
	}
	.body {
		margin-bottom: 32px;
		color: ${(props) => props.theme.new.colors.sol_gray_600};
		line-height: 1.5;
		font-size: 16px;
	}
`
